import { type ReactNode } from "react";
import { useSession } from "@/lib/auth/session";
import type { Permission } from "@/lib/permissions/catalog";

export function usePermission(perm: Permission | string): boolean {
  return useSession((s) => s.hasPermission(perm));
}

type CanProps = {
  permission: Permission | string;
  /** Si no tiene el permiso, qué renderiza (default: null). */
  fallback?: ReactNode;
  children: ReactNode;
};

/**
 * Renderiza `children` solo si el user actual tiene el permiso.
 *
 * IMPORTANTE: ocultar UI no es seguridad. La fuente de verdad vive en el
 * backend con `requirePermission(perm)`. `<Can>` es solo UX para no
 * mostrar botones que el server va a rechazar igual.
 */
export function Can({ permission, fallback = null, children }: CanProps) {
  const allowed = usePermission(permission);
  return <>{allowed ? children : fallback}</>;
}
